module.exports = "/assets/ok.png?zX9zuBE";